// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu_wrapper__248r2","condition":"menu_condition__dfgYn"};